import React from "react";

import { Stack } from "@mui/material";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { GHOST_PREVIEW_OPACITY } from "@/features/LiveFormEditor/LivePreview/ghostPreview.constant";
import { FormDivider } from "@/forms-design-system/FormDivider";

export type AdditionalQuestionsProps = {
  isPreview?: boolean;
  withDividers?: boolean;
  children: React.ReactNode;
};

export const AdditionalQuestions = ({
  isPreview = false,
  withDividers = false,
  children,
}: AdditionalQuestionsProps) => {
  return (
    <Stack
      direction="column"
      gap={2}
      divider={withDividers ? <FormDivider /> : undefined}
      sx={{ opacity: isPreview ? GHOST_PREVIEW_OPACITY : undefined }}
      data-test="questions-one-rate"
    >
      {children}
    </Stack>
  );
};
